import { getMemberListProc } from '@/appLogic/leanpath/wrappers';
import { getUserId } from '@/awsCodes/awsUtils';

/**
 * ユーザー情報に関するサービス
 */
export class IUserService {
  /**
   * 企業内に登録しているユーザーのメールアドレスを取得する
   */
  public static getOrganizationUserEmail = async (): Promise<string[]> => {
    const email = getUserId();
    // ログインユーザーの情報が取れなかった時
    if (!email) {
      console.error('Could not retrieve user email address.');
      return [];
    }

    // 組織内のメンバーの情報取得
    const memberArray = await getMemberListProc();
    // 出力用の配列
    const outputAddressArray: string[] = [];

    // 配列の先頭にリマインド登録者のメールアドレスと入れるようにする
    outputAddressArray.push(email);

    // リマインド登録者以外のユーザーのメールアドレスを配列に追加する
    memberArray.forEach((member) => {
      // memberの情報が存在し、メールアドレスがログインユーザーのものでは無い場合配列にpushする
      if (member && member.email && member.email !== email) outputAddressArray.push(member.email);
    });
    return outputAddressArray;
  };
}
